import { isFunction, isObject } from '#core/utils/is'

/**
 * Finds nested object entry by value/callback.
 * @param obj - target object
 * @param val - value to find or callback function which takes "key" and "value" params and returns boolean value
 * @returns - array in format: [key, value]
 * @example
 * findObjectEntry({ level1: { level2: 'test' }}, 'test')
 * returns ['level2', 'test']
 * @category Utils
 */
export const findObjectEntry = (
  obj: object,
  val: string | number | ((key: string, value: any) => boolean)
): [string, any] | null => {
  if (isObject(obj)) {
    for (const key in obj) {
      const value = obj[key]
      if (isFunction(val) ? val(key, value) : value === val) {
        return [key, value]
      }
      else {
        const result = findObjectEntry(value, val)
        if (result !== null) return result
      }
    }
  }

  return null
}
